import { render, staticRenderFns } from "./ProductSearchAreaStockMove.vue?vue&type=template&id=1ec9d7bf&scoped=true&"
import script from "./ProductSearchAreaStockMove.vue?vue&type=script&lang=js&"
export * from "./ProductSearchAreaStockMove.vue?vue&type=script&lang=js&"
import style0 from "./ProductSearchAreaStockMove.vue?vue&type=style&index=0&id=1ec9d7bf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec9d7bf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
